/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letter_SpacingInputs */

const en_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letter Spacing`)
};

const es_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaciado de letras`)
};

const fr_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacement des lettres`)
};

const de_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichenabstand`)
};

const ja_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字間隔`)
};

const zh_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字母间距`)
};

const ar_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تباعد الأحرف`)
};

const id_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jarak Huruf`)
};

const it_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spaziatura lettere`)
};

const ru_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Межбуквенный интервал`)
};

const pt_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaçamento de letras`)
};

const ko_letter_spacing = /** @type {(inputs: Letter_SpacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자간`)
};

/**
* | output |
* | --- |
* | "Letter Spacing" |
*
* @param {Letter_SpacingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const letter_spacing = /** @type {((inputs?: Letter_SpacingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letter_SpacingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letter_spacing(inputs)
	if (locale === "es") return es_letter_spacing(inputs)
	if (locale === "fr") return fr_letter_spacing(inputs)
	if (locale === "de") return de_letter_spacing(inputs)
	if (locale === "ja") return ja_letter_spacing(inputs)
	if (locale === "zh") return zh_letter_spacing(inputs)
	if (locale === "ar") return ar_letter_spacing(inputs)
	if (locale === "id") return id_letter_spacing(inputs)
	if (locale === "it") return it_letter_spacing(inputs)
	if (locale === "ru") return ru_letter_spacing(inputs)
	if (locale === "pt") return pt_letter_spacing(inputs)
	return ko_letter_spacing(inputs)
});